module.exports = __webpack_public_path__ + "media/img/pages/companies/huawei-c590117e09abb47f96e6f07ad761fa8b.png";